import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getInstructions } from '../../communication/CadessAPICommun';

class Instructions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      html: null,
    };
  }

  componentWillMount() {
    const {
      user: {
        _id,
        role,
      },
    } = this.props;

    getInstructions(_id, role).then(data => {
      this.setState({ html: data });
    });
  }

  render() {
    return (<div dangerouslySetInnerHTML={{ __html: this.state.html }} />);
  }
}

const mapStateToProps = ({ auth }) => {
  const { user } = auth;
  return {
    user,
  };
};

export default connect(mapStateToProps)(Instructions);
